"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AllSections = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _UncollapsedSubMenu = require("./UncollapsedSubMenu");
var _FullSubMenu = require("./FullSubMenu");
var _PartialSubMenu = require("./PartialSubMenu");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AllSections = props => {
  const {
    sectionProps
  } = props;
  const {
    content,
    collapsed
  } = sectionProps;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `category-section-${content?.text}`
  }, collapsed && /*#__PURE__*/_react.default.createElement("p", {
    // id={formatID(`${content?.text}-mega-menu-left-header-text`)}
    className: "ter-mega-menu__category-title"
  }, content?.text), content?.links?.map((category, i) => {
    const menuProps = {
      ...sectionProps,
      category
    };
    if (!collapsed) {
      return /*#__PURE__*/_react.default.createElement(_UncollapsedSubMenu.UncollapsedSubMenu, {
        menuProps: menuProps,
        index: i,
        key: `uncollapsed-submenu-${category?.text}-${i}`
      });
    } else if (category.links) {
      return /*#__PURE__*/_react.default.createElement(_FullSubMenu.FullSubMenu, {
        menuProps: menuProps,
        key: `full-submenu-${category?.text}-${i}`
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_PartialSubMenu.PartialSubMenu, {
        menuProps: menuProps,
        key: `partial-submenu-${category?.text}-${i}`
      });
    }
  }));
};
exports.AllSections = AllSections;